import React, { useState, useCallback, useEffect } from "react";
import "./organization-discount-add-edit.scss";

import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import { selectCurrentOrganization } from "../../reducers/organizationSlice";

import {
  clearNotifications,
  selectDiscountNotifications,
  selectDiscount,
  saveOrganizationDiscount,
  addOrganizationDiscount,
  getOrganizationDiscountCode,
  setSelectedDiscount,
} from "../../reducers/discountSlice";

import { addDiscountForm } from "../../forms/OrganizationForm";

const OrganizationDiscountAddEdit = () => {
  const [isValid, setIsValid] = useState(false);
  const [discount, setDiscount] = useState({
    description: "",
    code: "",
    status: "active",
    discountDollarAmount: "",
    discountPercentage: "",
    activateOn: "",
    deactivateOn: "",
    discountType: { id: 1, label: "Fixed Amount", value: 1 },
    discountUsage: { id: 1, label: "Unlimited Use", value: 1 },
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/discounts/:discountID/*");

  const orgNotifications = useSelector(selectDiscountNotifications);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const currentDiscount = useSelector(selectDiscount);

  const loadDiscount = useCallback(() => {
    if (matchEdit?.params?.discountID !== "add") {
      dispatch(getOrganizationDiscountCode(matchEdit?.params?.discountID));
    } else {
      dispatch(setSelectedDiscount({}));
    }
  }, [dispatch, matchEdit?.params?.discountID]);

  useEffect(() => {
    loadDiscount();
    return () => {
      dispatch(setSelectedDiscount({}));
    };
  }, [loadDiscount, dispatch]);

  useEffect(() => {
    if (currentDiscount?.id) {
      if (matchEdit?.params?.discountID !== currentDiscount?.id) {
        navigate(
          `/${matchEdit?.params?.id}/discounts/${currentDiscount?.id}/edit`
        );
      } else {
        let d = { ...currentDiscount };
        d.discountType = d.discountDollarAmount
          ? { id: 1, label: "Fixed Amount", value: 1 }
          : { id: 2, label: "Percentage", value: 2 };

        d.discountUsage = d.quantity
          ? { id: 2, label: "Limited Use", value: 2 }
          : { id: 1, label: "Unlimited Use", value: 1 };

        setDiscount(d);
      }
    } else {
      setDiscount({
        description: "",
        code: "",
        discountDollarAmount: "",
        discountPercent: "",
        activateOn: "",
        deactivateOn: "",
        status: "active",
        quantity: "",
        discountType: { id: 1, label: "Fixed Amount", value: 1 },
        discountUsage: { id: 1, label: "Unlimited Use", value: 1 },
      });
    }
  }, [currentDiscount, matchEdit?.params?.discountID , matchEdit?.params?.id, navigate]);

  let context = {};

  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };

  context.updateDiscount = (value, property) => {
    setIsValid(true);
    let d = { ...discount };
    d[property] = value;
    setDiscount(d);
  };

  context.isEditable = () => {
    return true;
  };

  const saveDiscount = () => {
    setIsValid(false);
    let save = { ...discount };
    if (discount?.discountType?.id === 1) {
      save.discountPercent = "";
    } else if (discount?.discountType?.id === 2) {
      save.discountDollarAmount = "";
    }
    if (discount.discountUsage.id === 1) {
      save.quantity = "";
    }
    if(save.activateOn)
    {
      save.activateOn = new Date(save.activateOn).toISOString()
    }
    if(save.deactivateOn)
    {
      save.deactivateOn = new Date(save.deactivateOn).toISOString()
    }
    dispatch(saveOrganizationDiscount(save));
  };

  const addDiscount = () => {
    setIsValid(false);
    let add = { ...discount };
    add.organization = currentOrganization;
    if(add.activateOn)
    {
      add.activateOn = new Date(add.activateOn).toISOString()
    }
    if(add.deactivateOn)
    {
      add.deactivateOn = new Date(add.deactivateOn).toISOString()
    }
    dispatch(addOrganizationDiscount(add));
  };

  const deleteDiscount = () => {
    const { id, discountID } = matchEdit.params;
    navigate(`/${id}/discounts/${discountID}/delete`);
  };

  const leftNavigation = () => {
    dispatch(clearNotifications());
    const { id } = matchEdit.params;
    navigate(`/${id}/discounts`);
  };

  const getActions = () => {
    let actions = [{ name: "cancel", action: leftNavigation, type: "grey" }];

    if (matchEdit?.params?.discountID === "add") {
      actions.unshift?.({
        name: "Save",
        isDisabled: !isValid,
        action: addDiscount,
        type: "black",
      });
    } else {
      actions?.unshift?.({
        name: "Save",
        isDisabled: !isValid,
        action: saveDiscount,
        type: "black",
      });

      actions?.push?.({
        name: "Delete Discount",
        action: deleteDiscount,
        type: "transparent red",
      });
    }
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Discount Details",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = orgNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };
  const timeoutAction = () => {
    dispatch(clearNotifications());
  };
  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to discount list",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };
  context.generateCode = () => {
    let newCode = Math.random()
      .toString(36)
      .substring(2, 10)
      .toUpperCase();
    context.updateDiscount(newCode, "code");
  };
  const getActiveAction = () => {
    return [
      {
        actionType: "toggle",
        value: true,
        pageActionProps: {
          falseDescription: "Inactive",
          rowReverse: true,
          onClick: (e) =>
            context.updateDiscount(
              discount?.status === "active" ? "inactive" : "active",
              "status"
            ),
          trueDescription: "Active",
          value: discount?.status === "active",
        },
      },
    ];
  };

  const getFormActionBar = () => {
    return {
      formTitle: matchEdit?.params?.discountID !== "add" ? "Edit Discount" : "Add Discount",
      formActions: getActiveAction(),
    };
  };

  const getContent = () => {
    return (
      <GSForm
        {...getFormActionBar()}
        formSections={addDiscountForm(context, discount)}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <organization-discount-add-edit>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-discount-add-edit>
  );
};

export default OrganizationDiscountAddEdit;
